import { useFormStore } from '@/stores/form'
import { useAuthStore } from '@/stores/auth'
import { useGlobalStore } from '@/stores/global'
import apiHelperService from '@/services'
import lookups from '@/assets/json/clientLookups.json'
import router from '@/router'

const disableDepartment = () => {
  const formStore = useFormStore()
  const authStore = useAuthStore()
  const { applicationId = '' } = authStore.user
  const {
    application: { citizen, gcc_citizen }
  } = lookups
  if (formStore.draft.request.individualInfo.defaultImmigrationDepartmentId > 0) {
    formStore.extraMap.disableDepartment = true
  }
  if ([citizen, gcc_citizen].includes(applicationId)) {
    formStore.extraMap.disableDepartment = false
  }
}

const initForm = async () => {
  const formStore = useFormStore()
  const globalStore = useGlobalStore()
  const { serviceTransactionId } = globalStore.startedService
  const { administrativeRegionId = '', withException = '' } = router.currentRoute.value.query
  formStore.extraMap = {
    ...formStore.extraMap,
    disableDepartment: false,
    isRequiredFields: 'required',
    serviceTransactionId,
    administrativeRegionId,
    withException: withException == 'true'
  }
}
const initInfo = async () => {
  const authStore = useAuthStore()
  const { applicationId = '' } = authStore.user
  if (applicationId == 2) return
  const formStore = useFormStore()
  const res = await apiHelperService.get(`/api/individual/info`)
  if (res) {
    const { defaultImmigrationDepartmentId = '', identityNumber = '' } = res
    formStore.draft.request = {
      ...formStore.draft.request,
      individualInfo: res,
      immigrationDepartmentId: defaultImmigrationDepartmentId,
      personIdentityNumber: identityNumber
    }
  }
}
export default async function () {
  try {
    await initForm()
    await initInfo()
    await disableDepartment()
  } catch (error) {
    console.error('use412Preload error: ', error)
  }
}
